// src/util/order.js
import pos from '@/services/poscrm'
import util from './util'

// ===== helper & constants ไว้ใช้ใน calculateReceiptSummary =====
const skipsKeys = [
  'vatBase',
  'queueIndex',
  'discountAmount',
  'serviceChargePercent',
  'numCust',
  'typeOfOrder',
  'gpPercent',
  'promotionDiscountAmount',
  'promotionDiscountItem',
  'providerDiscountAmount',
  'eaterPayment',
]

const noServiceChargeOrder = [2, 3, 4] // ตามสูตร backend

const toNum = (value) => {
  if (value == null || value === '' || isNaN(value)) return 0
  return Number(value)
}

const safeDivide = (numerator, denominator) => {
  const den = toNum(denominator)
  if (den === 0) return 0
  return toNum(numerator) / den
}

const round2 = (num) => Number((+num || 0).toFixed(2))

export default {
  updateOrder(data) {
    let order = {
      status: 'CANCEL',
      reason: 'cancel order by customer',
    }

    data.order = order

    pos({
      url: '/api/v1.1/' + data.uid + '/Receipt/updateorder',
      data: data,
      method: 'post',
    }).then((res) => {

    })
  },

  cancelOrder(data) {
    pos({
      url: '/api/v1.1/' + data.uid + '/Receipt/cancelorder',
      data: data,
      method: 'post',
    }).then((res) => {

    })
  },

  updateAmount(data, quantity) {
    let amount = 0
    let quantitySKU = quantity * data.ratio

    let price = 0.0
    if (data.price !== undefined) {
      price = data.price

      let optionPrice = 0
      for (let item in data.orderedOptions) {
        if (data.orderedOptions[item].price !== undefined) {
          optionPrice += data.orderedOptions[item].price
        }

      }

      amount = (data.price + optionPrice) * quantity
    } else {
      price = data.productSKU.SKUPrice
      amount = quantitySKU * data.productSKU.SKUPrice
    }

    return {
      price: price,
      amount: amount,
      quantitySKU: quantitySKU,
    }
  },

  updateAmountDelivery(data, quantity) {
    let newData = data
    let newQuantity = data.quantity + quantity
    let optionPrice = 0
    for (let item in data.orderedOptions) {
      if (data.orderedOptions[item].price !== undefined) {
        optionPrice += data.orderedOptions[item].price
      }
    }
    let newTotalAmount = (data.price + optionPrice) * newQuantity

    newData.totalAmount = newTotalAmount
    newData.quantity = newQuantity

    return newData
  },

  createReceiptItemsDelivery(SKUData, PLUData, quantity, note, orderedOptions, profile) {
    const quantitySKU = quantity * PLUData.SKURatio
    const id = util.createObjectId()
    let options = []

    let totalOption = 0.0
    let exceedUc = 0.0

    if (orderedOptions.length > 0) {
      options = this.createOrderOptionDefault(SKUData.id, orderedOptions)

      options.forEach((item) => {
        if (item.price !== undefined) {
          totalOption += item.price
        }
      })
    }
    let priceBase = 0.0
    if (PLUData.ProductPRU) {
      const pru = PLUData.ProductPRU

      // priceBase =
      //   (pru.packUc ?? 0) === 0
      //     ? (pru.exceedUc ?? 0) * (pru.packQty ?? 0)
      //     : (pru.packUc ?? 0)

      exceedUc = PLUData.ProductPRU.exceedUc
    } else {
      exceedUc = SKUData.SKUPrice ?? 0
    }

    const totalAmount = (exceedUc + totalOption) * quantity

    let data = {
      profile: {
        objectId: profile.objectId,
        id: profile.id,
        name: profile.name,
      },
      shop: SKUData.shop,
      productPLU: {
        unit: {
          objectId: PLUData.unit.objectId,
          id: PLUData.unit.id,
          name: PLUData.unit.name
        },
        objectId: PLUData.objectId,
        enabled: true,
        name: PLUData.name,
        SKURatio: PLUData.SKURatio,
        indexColor: SKUData.indexColor,
        id: PLUData.id,
        PLUCode: PLUData.PLUCode,
        ...(PLUData.nameTranslation && { nameTranslation: PLUData.nameTranslation }),
      },
      productSKU: {
        objectId: SKUData.objectId,
        SKUName: SKUData.SKUName,
        SKUPrice: SKUData.SKUPrice,
        enabled: true,
        id: SKUData.id,
        indexColor: SKUData.indexColor,
        isOnScreen: true,
        serviceCharge: SKUData.serviceCharge,
        skuType: SKUData.skuType,
        vatType: SKUData.vatType,
        stdCost: SKUData.stdCost
      },
      totalAmount: totalAmount,
      price: exceedUc,
      remoteImagePath: SKUData.remoteImagePath,
      note: note,
      quantity: quantity,
      isSelected: true,
      ...(SKUData.nameTranslation && { nameTranslation: SKUData.nameTranslation }),
      ...(SKUData.descriptionTranslation && { descriptionTranslation: SKUData.descriptionTranslation }),
    }
    if (options.length > 0) {
      data['orderedOptions'] = options
    }
    return data

  },

  createReceiptItemsDefault(SKUData, PLUData, quantity, note, orderedOptions) {
    const quantitySKU = quantity * PLUData.SKURatio
    const id = util.createObjectId()
    let options = []

    let totalOption = 0.0
    let exceedUc = 0.0

    if (orderedOptions.length > 0) {
      options = this.createOrderOptionDefault(SKUData.id, orderedOptions)

      options.forEach((item) => {
        if (item.price !== undefined) {
          totalOption += item.price
        }
      })
    }

   let priceBase = 0.0
   if (PLUData.ProductPRU) {
      const pru = PLUData.ProductPRU

      // priceBase =
      //   (pru.packUc ?? 0) === 0
      //     ? (pru.exceedUc ?? 0) * (pru.packQty ?? 0)
      //     : (pru.packUc ?? 0)

      // exceedUc = priceBase
      exceedUc = PLUData.ProductPRU.exceedUc
    } else {
      exceedUc = SKUData.SKUPrice ?? 0
    }

    const totalAmount = (exceedUc + totalOption) * quantity
    const name = localStorage.getItem('name') || ''

    let data = {
      shop: SKUData.shop,
      shopId: SKUData.shopId,
      uid: SKUData.uid,
      id: id,
      category: SKUData.category,
      categoryId: SKUData.categoryId,
      categoryName: SKUData.category.name,
      created_at: new Date(),
      created_by: SKUData.created_by,
      created_by_id: SKUData.created_by_id,
      indexColor: SKUData.indexColor,
      skuType: SKUData.skuType,
      stdCost: SKUData.stdCost,
      vatType: SKUData.vatType,
      updated_at: SKUData.updated_at,
      updated_by: SKUData.updated_by,
      updated_by_id: SKUData.updated_by_id,
      unit: SKUData.unit,
      remoteImagePath: SKUData.remoteImagePath,
      productPLU: {
        PLUCode: PLUData.PLUCode,
        SKURatio: PLUData.SKURatio,
        id: PLUData.id,
        name: PLUData.name,
        objectId: PLUData.objectId,
        unit: PLUData.unit,
        ...(PLUData.nameTranslation && { nameTranslation: PLUData.nameTranslation }),
      },
      pluCode: PLUData.PLUCode,
      pluName: PLUData.name,
      productPLUId: PLUData.id,
      productSKU: PLUData.productSKU,
      productSKUId: PLUData.productSKUId,
      ratio: PLUData.SKURatio,
      discountAmount: 0,
      discountBillPerQty: 0,
      quantity: quantity,
      quantitySKU: quantitySKU,
      netAmount: totalAmount,
      totalAmount: totalAmount,
      price: exceedUc,
      note: note,
      status: 'N',
      serviceCharge: SKUData.serviceCharge,
      ordered_by: name,
      ...(SKUData.nameTranslation && { nameTranslation: SKUData.nameTranslation }),
      ...(SKUData.descriptionTranslation && { descriptionTranslation: SKUData.descriptionTranslation }),
    }
    if (options.length > 0) {
      data['orderedOptions'] = options
      return data
    } else {
      return data
    }
  },

  orderDefault(uid, shop, receiptItems, payment) {
    return {
      uid: uid,
      shopObjectId: shop.objectId,
      receipt: {
        order: {
          orderInputType: 'SMART-MENU',
        },
        uid: shop.uid,
        shop: {
          branchName: shop.branchName,
          id: shop.id,
          objectId: shop.objectId,
        },
        shopId: shop.id,
        receiptItems: receiptItems,
        objectId: '',
        created_at: '',
        id: '',
        lastUpdated: '',
        payReceiptAt: payment.payReceiptAt,
        payment: payment.payment,
        paymentId: payment.paymentId,
        pos: {
          id: '',
          objectId: '',
          posNumber: '',
        },
        posId: '',
        productNames: [],
        serverTimestamp: '',
        discountAmount: 0,
        discountItem: 0,
        grandTotal: 0,
        netAmount: 0,
        netAmountIncServiceCharge: 0,
        netAmountIncVAT: 0,
        netAmountNonVAT: 0,
        netAmountVATTotal: 0,
        netTotal: 0,
        netTotalIncVAT: 0,
        netTotalNonVAT: 0,
        quantityIncVAT: 0,
        quantityNonVAT: 0,
        // queueIndex: 0,
        serviceCharge: 0,
        serviceChargePercent: 0,
        isVATIncluded: true,
      },
    }
  },

  orderDineIn(uid, shop, receiptItems, table, timestamp, pax, tableLayout = false) {
    const numCust = parseInt(pax);
    const tableInfo = tableLayout === true
      ? { tableLayout: { objectId: table.objectId, name: table.name } }
      : { table: { id: table.id, objectId: table.objectId, name: table.name } };

    return {
      uid: uid,
      shopObjectId: shop.objectId,
      receipt: {
        numCust: numCust,
        QRTimestamp: timestamp,
        source: 'SELF_ORDER',
        receiptStatus: 'O',
        ...tableInfo,
        tableId: tableLayout ? table.objectId : table.id,
        tableName: table.name,
        order: {
          orderInputType: 'SMART-MENU',
        },
        uid: shop.uid,
        shop: {
          branchName: shop.branchName,
          id: shop.id,
          objectId: shop.objectId,
        },
        shopId: shop.id,
        receiptItems: receiptItems,
        objectId: '',
        created_at: '',
        id: '',
        lastUpdated: '',
        pos: {
          id: '',
          objectId: '',
          posNumber: '',
        },
        posId: '',
        productNames: [],
        serverTimestamp: '',
        discountAmount: 0,
        discountItem: 0,
        grandTotal: 0,
        netAmount: 0,
        netAmountIncServiceCharge: 0,
        netAmountIncVAT: 0,
        netAmountNonVAT: 0,
        netAmountVATTotal: 0,
        netTotal: 0,
        netTotalIncVAT: 0,
        netTotalNonVAT: 0,
        quantityIncVAT: 0,
        quantityNonVAT: 0,
        // queueIndex: 0,
        serviceCharge: 0,
        serviceChargePercent: 0,
        isVATIncluded: true,
      },
    };
  },

  createOrderOptionDefault(receiptItemId, data) {
    try {
      return data.map(item => {
        const objectId = util.createObjectId();
        const id = util.createObjectId();
        const optionItem = item.items[0];
        const optionGroup = item.OptionGroup;
        const itemId = optionItem.id
        const filterItemInGroupId = optionGroup.items.filter(item => item.optionItem.id === itemId);
        const itemInGroupId = filterItemInGroupId[0].id
        const activeOptionId = item.id ?? ''

        let resp = {
          optionItemName: optionItem.name,
          ...(optionItem.nameTranslation && { nameTranslation: optionItem.nameTranslation }),
          optionItem: {
            id: optionItem.id,
            objectId: optionItem.objectId,
            name: optionItem.name,
            ...(optionItem.nameTranslation && { nameTranslation: optionItem.nameTranslation }),
          },
          itemInGroupId: itemInGroupId,
          optionGroup: {
            id: optionGroup.id,
            objectId: optionGroup.objectId,
            name: optionGroup.name,
            ...(optionGroup.nameTranslation && { nameTranslation: optionGroup.nameTranslation }),
          },
          optionItemId: optionItem.id,
          activeOptionId: activeOptionId,
          receiptItemId: receiptItemId,
          optionProductPLUs: [],
          objectId: objectId,
          quantity: 1,
          id: id,
        };


        if (optionItem.price !== undefined) {
          resp.price = optionItem.price
        }

        if (optionItem.cost !== undefined) {
          resp.cost = optionItem.cost
        }
        return resp;
      });
    } catch (error) {
      console.error("Error creating order option default:", error);
      return [];
    }
  },

  // ========= ใช้สูตร calculateReceiptItems ฝั่ง backend (เวอร์ชันสรุป) =========
  calculateReceiptSummary(originalReceipt = {}) {
    const receipt = JSON.parse(JSON.stringify(originalReceipt))

    // reset number fields (ยกเว้น keys ใน skipsKeys)
    Object.keys(receipt).forEach((key) => {
      const val = receipt[key]
      if (val != null && typeof val === 'number' && !skipsKeys.includes(key)) {
        receipt[key] = 0
      }
    })

    if (typeof receipt.vatBase !== 'number') {
      receipt.vatBase = 7
    }
    if (typeof receipt.totalCost !== 'number') {
      receipt.totalCost = 0
    }

    let receiptQty = 0
    let itemTotalAmount = 0   // sum totalAmount
    let itemNetAmount = 0     // sum netAmount
    let serviceChargeBase = 0 // base สำหรับคิด service charge
    let serviceChargeQty = 0

    receipt.netAmountIncVAT = receipt.netAmountIncVAT || 0
    receipt.netTotalIncVAT = receipt.netTotalIncVAT || 0
    receipt.netAmountNonVAT = receipt.netAmountNonVAT || 0
    receipt.netTotalNonVAT = receipt.netTotalNonVAT || 0
    receipt.quantityIncVAT = receipt.quantityIncVAT || 0
    receipt.quantityNonVAT = receipt.quantityNonVAT || 0
    receipt.discountItem = toNum(receipt.discountItem || 0)

    const items = Array.isArray(receipt.receiptItems) ? receipt.receiptItems : []

    for (const item of items) {
      try {
        if (item && item.deleted_at == null) {
          const itemTotal = toNum(item.totalAmount)
          const itemNet = toNum(item.netAmount != null ? item.netAmount : item.totalAmount)
          const qty = toNum(item.quantity)

          itemTotalAmount += itemTotal
          itemNetAmount += itemNet
          receiptQty += qty

          if (item.totalCost != null) {
            receipt.totalCost = toNum(receipt.totalCost) + toNum(item.totalCost)
          }

          receipt.discountItem += toNum(item.discountAmount || 0)

          if (item.vatType === 'V') {
            receipt.netAmountIncVAT += itemNet
            receipt.netTotalIncVAT += itemNet
            receipt.quantityIncVAT += qty
          } else {
            receipt.netAmountNonVAT += itemNet
            receipt.netTotalNonVAT += itemNet
            receipt.quantityNonVAT += qty
          }

          if (item.serviceCharge === true) {
            serviceChargeBase += itemNet
            serviceChargeQty += qty
          }
        }
      } catch (e) {
        console.error(e)
      }
    }

    const promotionDiscount =
      toNum(receipt.promotionDiscountAmount) +
      toNum(receipt.promotionDiscountItem)

    let discountBillPerQty = 0
    if (receiptQty !== 0) {
      discountBillPerQty = safeDivide(receipt.discountAmount || 0, receiptQty)
    }

    // หักส่วนลดบิลออกจากฐาน service charge
    const serviceChargeDiscount = serviceChargeQty * discountBillPerQty
    serviceChargeBase = serviceChargeBase - serviceChargeDiscount

    if (noServiceChargeOrder.includes(receipt.typeOfOrder)) {
      serviceChargeBase = 0
    }

    const serviceChargePercent = toNum(receipt.serviceChargePercent)
    const serviceCharge = serviceChargeBase * (serviceChargePercent / 100)

    receipt.netAmount = itemTotalAmount
    receipt.netTotal = itemNetAmount

    // netTotalIncVAT
    receipt.netTotalIncVAT = receipt.netAmountIncVAT
    if (receipt.netAmountIncVAT > 0) {
      receipt.netTotalIncVAT =
        receipt.netAmountIncVAT -
        discountBillPerQty * receipt.quantityIncVAT -
        promotionDiscount
    }

    // netTotalNonVAT
    receipt.netTotalNonVAT = receipt.netAmountNonVAT
    if (receipt.netAmountNonVAT > 0) {
      receipt.netTotalNonVAT =
        receipt.netAmountNonVAT -
        discountBillPerQty * receipt.quantityNonVAT -
        promotionDiscount
    }

    receipt.netTotal = receipt.netTotalIncVAT + receipt.netTotalNonVAT

    // VAT included case
    let netAmountIncVATserviceCharge =
      toNum(receipt.netTotalIncVAT) + serviceCharge
    let netAmountVATTotal =
      netAmountIncVATserviceCharge /
      ((100 + toNum(receipt.vatBase)) / 100)

    let vatAmount = netAmountIncVATserviceCharge - netAmountVATTotal

    // grandTotal base
    let grandTotal =
      toNum(receipt.netAmount) -
      toNum(receipt.discountItem) -
      toNum(receipt.discountAmount || 0) +
      serviceCharge -
      promotionDiscount

    // ถ้า isVATIncluded != true → คิด VAT แยก
    if (receipt.isVATIncluded !== true) {
      let grandTotalIncVAT =
        toNum(receipt.netAmountIncVAT) -
        discountBillPerQty * toNum(receipt.quantityIncVAT) +
        serviceCharge

      vatAmount = grandTotalIncVAT * (toNum(receipt.vatBase) / 100)
      netAmountVATTotal = grandTotalIncVAT
      grandTotal = grandTotal + vatAmount
    }

    return {
      netAmount: round2(itemTotalAmount),
      vatAmount: round2(vatAmount),
      serviceCharge: round2(serviceCharge),
      grandTotal: round2(grandTotal),
      netTotal: round2(receipt.netTotal),
      netTotalIncVAT: round2(receipt.netTotalIncVAT),
      netTotalNonVAT: round2(receipt.netTotalNonVAT),
    }
  },
}
